/**
 * Copyright.
 *
 * @format
 */
/* eslint-disable max-len */

import React from 'react';
import Translate from '@components/translation/translate-text-wrapper';

const Copyright = (): JSX.Element => {
  const currentYear: number = new Date().getFullYear();

  return (
    <div className="copyright-wrapper">
      <div className="container flex-columns">
        <div className="copyright">
          <p className="copyright-year">
            © 1999-{currentYear} Varian, A Siemens Healthineers Company, &nbsp;
            <Translate>All Rights reserved.</Translate>
          </p>
          <p>
            <Translate>
              Production of any of the material contained herein in any format
              or media without the express written permission of Varian, A
              Siemens Healthineers Company, is prohibited.
            </Translate>
          </p>
        </div>
        <div className="trust-e">
          <div className="trust-e-container">
            <div id="consent_blackbar" />
            <div id="teconsent" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Copyright;
